// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls__BuildControls__3_01f","controlHeader":"BuildControls__controlHeader__3UbWD","price":"BuildControls__price__1vpy7","orderButton":"BuildControls__orderButton__1Bd1C","orderButtonActive":"BuildControls__orderButtonActive__1XBMk","Footer":"BuildControls__Footer__30jT-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControls.css
// module id = 146
// module chunks = 0